import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BaseService, AuthHttpService } from '../../';


export class ExportService extends BaseService {

	private baseUrl: string = '/v1/export/guest/client';

	constructor(private authHttp: AuthHttpService) {
		super();
	}

	public exportProfile(): Observable<any> {
		let url: string = this.baseUrl + '/application_stage/candidate/exported_profile';
		return this.authHttp.get(url)
			.map(this.extractResponseData)
			.catch((err) => this.handleError(err, '?qp_alert=c_p_guest_error'));
	}
}(ExportService as any).ctorParameters = function () { return [ { type: AuthHttpService } ]; }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/services/export/client/export.service.ts